app.component("recordVisitMenu", {
	templateUrl: "app/src/js/components/patientHeader/recordVisitMenu/recordVisitMenu.html",
	controller: "recordVisitMenuController",
	bindings: {
		showButton: '<',
		hide: "&",
	},
});

app.controller("recordVisitMenuController", [
	"$scope",
	"$state",
	"Session",
	"CurrentPatient",
	"ContactAPI",
	"PatientAPI",
	"ReferralsAPI",
	"CurrentReferral",
	function ($scope, $state, Session, CurrentPatient, ContactAPI, PatientAPI, ReferralsAPI, CurrentReferral) {
		$scope.CP = CurrentPatient;
		// Worked out again whenever the user's permissions are re-read, so the menu never offers stale actions.
		function applyPermissions() {
			$scope.canManageSurgeryAgreement = Session.hasPermission("SURGERY_AGREEMENT_MANAGE");
			$scope.canIssueMedicalCertificate = Session.hasPermission("CLINICAL_MEDICAL_CERTIFICATE_ISSUE");
			$scope.canStartWorkup = Session.canStartWorkup();
			$scope.showOperationNoteButton = Session.hasPermission("SURGERY_OPERATION_NOTE_WRITE");
			$scope.canWriteInjectionNote = Session.hasPermission("CLINICAL_INJECTION_NOTE_WRITE");
		}
		$scope.$watch(function () {
			return Session.permissions;
		}, applyPermissions);
		applyPermissions();
		$scope.ContactAPI = ContactAPI;
		$scope.PA = PatientAPI;
		$scope.RA = ReferralsAPI;
		$scope.CR = CurrentReferral;
		$scope.hasProfessionalRegistration = Session.hasProfessionalRegistration();

		$scope.startClinicalNote = function () {
			$state.go("clinical-note");
		}

		$scope.clinicalExamination = function () {
            $scope.PA.isProcessing = true;
            $scope.RA.startReferral().then(
                function (resp) {
                    $scope.CR.setReferral(resp.data);
                    // $scope.patientDetailsModal.hide();
                    $scope.PA.isProcessing = false;
                    $state.go("examination");
                },
                function (err) {
                    console.error("Failed to start referral:", err && err.status);
                    $scope.PA.isProcessing = false;
                }
            );
        };

		$scope.startInjectionNote = function () {
			$state.go("injection-note");
		}

		$scope.startWorkUp = function () {
			$state.go("pre-op");
		};

		$scope.startOperationNote = function () {
			$state.go("operation-note");
		};

		$scope.openSurgeryAgreement = function () {
		//    $scope.$ctrl.hide();
        //    $scope.$ctrl.openSurgeryAgreement();
			$state.go("surgery-agreement");
		}

		$scope.openMedicalCertificate = function (isReturnToWork) {
			if (!$scope.hasProfessionalRegistration) {
				return;
			}
			$state.go('medical-certificate',{isReturnToWork});
		}

	},
]);
